import gql from 'graphql-tag';

export default gql `
query listActivities ($first: Int, $after: String) {
    listActivities (first: $first, after: $after) {
			items {
				id
				username
				actDate
				activityType
				value
				intensity
				notes
			}
			nextToken
	}	
}`;


// WEBPACK FOOTER //
// ./src/components/queries/ListActivitiesQuery.js